export default function SalesBanner() {
  // Reusable component to render banner messages
  const createBannerMessage = (text, linkText, href) => (
    <>
      {" "}
      {text}{" "}
      <a href={href} target="_blank" className="text-warning" rel="noreferrer">
        {linkText}
      </a>
    </>
  );

  const bannerMessages = [
    createBannerMessage(
      "👋 Strategists, TargetSmart can help you exclude known early voters from your GOTV universe.",
      "Contact Us",
      "https://targetsmart.com/#hpcontactus"
    ),
    createBannerMessage(
      "👋 Last minute digital buys? We can help reach applicants",
      "or exclude those who have returned their ballots!",
      "https://targetsmart.com/#hpcontactus"
    ),
    createBannerMessage(
      "💡 TargetSmart Insights: TargetSmart's tip sheet provides regular updates on the latest voter registration, early vote, and voter turnout trends.",
      "TargetSmart Insights",
      "https://targetsmart.com/insights-newsletters/"
    ),
    createBannerMessage(
      "📞 30 million wireless numbers were added to our voter file. Contact us about",
      "CellBase",
      "https://targetsmart.com/cellbase"
    ),
    createBannerMessage(
      "✨ New for Campaigns ✨ Remove early voters from your digital ads to improve your effectiveness with TargetSmart’s",
      "Media Buying Platform.",
      "https://mbp.targetsmart.com/"
    ),
  ];

  const bannerMessage =
    bannerMessages[Math.floor(Math.random() * bannerMessages.length)];

  return (
    <div className="bg-dark text-white w-100 p-1 text-center">
      {bannerMessage}
    </div>
  );
}
